import { StyleRules } from '@material-ui/core/styles';
import { FormLabelClassKey } from '@material-ui/core/FormLabel';

import { core as theme } from '../styles/core';

export const MuiFormLabel: Partial<StyleRules<FormLabelClassKey>> = {
  root: {
    ...theme.typography.caption,
    margin: 0,
    color: theme.palette.grey[700],
  },
  asterisk: {
    color: theme.palette.primary.main,
    '.Mui-disabled &': {
      color: 'inherit',
    },
  }
};
